



<ng-template #template>

  <div class="tab-container">
    <mat-tab-group #tabRef>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="custom-class">Hour</span>
        </ng-template>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="custom-class">Day</span>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>

  <div class="tile-container">

    <ng-container *ngIf="tabRef.selectedIndex == 0">
      <ng-container *ngIf="totalMissedCallsByHourResults | async as _totalMissedCallsByHourResults; else (loading$ | async)">

        <line-chart *ngIf="_totalMissedCallsByHourResults.length > 0 else (noResults$ | async)"
                    [results]="_totalMissedCallsByHourResults"
                    [options]="totalMissedCallsOptions"
                    (select)="onSelect($event)">
        </line-chart>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="tabRef.selectedIndex == 1">
      <ng-container *ngIf="totalMissedCallsByDayResults | async as _totalMissedCallsByDayResults; else (loading$ | async)">

        <line-chart *ngIf="_totalMissedCallsByDayResults.length > 0 else (noResults$ | async)"
                    [results]="_totalMissedCallsByDayResults"
                    [options]="totalMissedCallsOptions"
                    (select)="onSelect($event)">
        </line-chart>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
